module.exports = __webpack_public_path__ + "static/img/nav_fix3.c3761247.png";